export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7470.4585ba60.jpg";